<template>
    <main>
       <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                     <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                     </div>
                     <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Branch</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Branchs/MenuList.vue";
import lang from "@/views/modules/Branchs/language/en";
import GenericEdit from "@/components/layout/shared/generic/EditView.vue";

export default {
name: "new-branch",
components: {
        breadcrumbs, 
        GenericEdit,
    },
    data(){
        return {
            generic: true,
            metaList:[
                {
                    type:'text',
                    name:'name',
                    label:lang.LBL_BRANCH_NAME,
                    required: true
                },
                {
                    type:'text',
                    name:'branch_code',
                    label:lang.LBL_BRANCH_CODE,
                    required: true
                },
                {
                    type:'text',
                    name:'tenant_id',
                    label:lang.LBL_TENANT_ID,
                    required: false
                },
                {
                    type:'text',
                    name:'upload_path',
                    label: lang.LBL_UPLOAD_DIR,
                    required: false
                },
                {
                    type:'textarea',
                    name:'description',
                    label: lang.LBL_DESCRIPTION,
                    required: false
                },
                {
                    type:'textarea',
                    name:'ip_address',
                    label: lang.LBL_IPADDRESS,
                    required: false
                },
                {
                    type:'selectbox',
                    name:'status',
                    label: lang.LBL_STATUS,
                    dom_access:true,
                    dom_key:'status_dom',
                    required: false
                },
                {
                    type:'selectbox',
                    name:'time_zone',
                    label: lang.LBL_BRANCH_TIMEZONE,
                    dom_access:true,
                    dom_key:'default_time_zone',
                    required: false
                },
                {
                    type:'checkbox',
                    name:'default_branch',
                    label: lang.LBL_DEFAULT_BRANCH,
                    value:'1',
                    required: false
                },
                {
                    type:'checkbox',
                    name:'for_mobileapp',
                    label: lang.LBL_SHOW_MOBILE_APP,
                    value:'1',
                    required: false
                },
            ],
            
            urls:'api/modules/branchs',
            
            routePath:{
                path:'branchs',
                detail:false
            }
            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
           
        }
    },
}
</script>